import "./sass/index.scss";
import renderApp from "./lib/renderApp";
import "./i18n/I18nApp";
import { App } from "app";

renderApp.withoutAuth(App);
